// src/services/admin.js
import axios from "axios";
import Cookies from "universal-cookie";

const cookies = new Cookies();
const url = cookies.get("url");
const rawUrl = cookies.get("url");
// eslint-disable-next-line
const user = cookies.get("user");
let token = cookies.get("token");

// fuerza protocolo si no viene
function normalizeUrl(u) {
  if (!u) return "";
  if (u.startsWith("http://") || u.startsWith("https://")) return u;
  return `http://${u}`; // o https según tu API
}

let headers = {
  "Content-type": "application/json; charset=UTF-8",
  Authorization: "Bearer " + token,
};
let baseUrl = `${normalizeUrl(rawUrl)}/api`;
//let baseUrl = `${url}/api`;

// Cuando cambie la URL en cookies
//function manejarCookieActualizada(event) {
//  baseUrl = `${event.detail.value}/api`;
//}

function manejarCookieActualizada(event) {
  const newUrl = normalizeUrl(event.detail.value);
  baseUrl = `${newUrl}/api`;
}

// Cuando cambie el token en cookies
function onUpdateToken(event) {
  token = event.detail.value;
  headers.Authorization = "Bearer " + token;
}

window.addEventListener("updatedUrl", manejarCookieActualizada);
window.addEventListener("tokenUpdatedEvent", onUpdateToken);

/**
 * LISTAR cuentas (signals / followers)
 * Endpoint: POST /api/admin/accounts
 * Body: { rol_filter, search_filter, groups_filter, activity_filter, exact_search }
 */
const accountsService = async (params) => {
  const res = await axios.post(`${baseUrl}/admin/accounts`, params, {
    headers,
  });
  return res;
};

/**
 * CREAR Signal o Follower
 * Endpoint backend: POST /api/admin/accounts/new
 * (se expone en helpers separados para que el componente no arme el body a mano)
 */
const createSignalAccount = async (formData, visibility) => {
  const body = {
    rol: "Signal",
    login: Number(formData.metatrader_login),
    strategy_name: formData.strategy_name,
    strategy_description: formData.strategy_description || null,
    strategy_type: formData.strategy_type,
    fee_value_percentage: Number(formData.fee_value_percentage),
    ib_account: Number(formData.ib_account),
    visibility: !!visibility,
    drawdown:
      formData.drawdown_mode === "NoDrawdown"
        ? "NoDrawdown"
        : formData.drawdown_mode, // "InEquity" | "InBalance"
    max_drawdown:
      formData.drawdown_mode === "NoDrawdown"
        ? 0
        : Number(formData.drawdown_amount || 0),
    disable_on_drawdown:
      formData.drawdown_mode === "NoDrawdown"
        ? false
        : formData.disable_on_drawdown === "Yes",
  };

  const res = await axios.post(`${baseUrl}/admin/accounts/new`, body, {
    headers,
  });
  return res;
};

const createFollowerAccount = async (formData, visibility) => {
  const body = {
    rol: "Follower",
    login: Number(formData.follower_login),
    signal_login: Number(formData.signal_login),
    copy_mode: formData.copy_mode,
    risk_ratio: Number(formData.risk_ratio),
    visibility_follower: !!visibility,
    min_lot_size: Number(formData.min_lot_size),
    max_lot_size: Number(formData.max_lot_size),
    drawdown:
      formData.drawdown_mode === "NoDrawdown"
        ? "NoDrawdown"
        : formData.drawdown_mode,
    max_drawdown:
      formData.drawdown_mode === "NoDrawdown"
        ? 0
        : Number(formData.drawdown_amount || 0),
  };

  const res = await axios.post(`${baseUrl}/admin/accounts/new`, body, {
    headers,
  });
  return res;
};

/**
 * EDITAR Signal o Follower
 * Endpoint: PUT /api/admin/accounts
 * (el payload ya lo armas en AccountsScreen)
 */
const editAccounts = async (params) => {
  const res = await axios.put(`${baseUrl}/admin/accounts`, params, {
    headers,
  });
  return res;
};

/**
 * BORRAR / UNLINK (Signal o Follower)
 * Endpoint: DELETE /api/admin/accounts
 * (body: { rol, login, ... })
 */
const deleteAccounts = async (params) => {
  const res = await axios.delete(`${baseUrl}/admin/accounts`, {
    headers,
    data: params, // axios requiere `data` para body en DELETE
  });
  return res;
};

/**
 * LISTA de grupos
 * Endpoint: GET /api/admin/group-list
 */
const getGroups = async () => {
  try {
    const res = await axios.get(`${baseUrl}/admin/group-list`, { headers });
    return res;
  } catch (error) {
    throw error;
  }
};

/**
 * INFORMACIÓN general (si en algún sitio se usa)
 * Endpoint: GET /api/admin/information
 */
const getInformation = async () => {
  const res = await axios.get(`${baseUrl}/admin/information`, { headers });
  return res;
};

/**
 * LOGS ADMIN
 * Endpoint: GET /api/admin/logs
 * Query params: { search?, code?, type?, from, to }
 *
 * Ejemplo de uso desde el front:
 *   adminMethods.getAdminLogs({ search, code, type, from, to })
 */
const getAdminLogs = async (params) => {
  // params debe ser un objeto con las keys: search, code, type, from, to
  const res = await axios.get(`${baseUrl}/admin/logs`, {
    headers,
    params, // axios serializa esto a ?search=...&code=...&type=...&from=...&to=...
  });
  return res;
};

/**
 * HISTORICAL SETTINGS
 * Endpoint: GET /api/admin/historical
 * Query params: { login, search, quantity, page }
 */
const getHistoricalSettings = async (params) => {
  // params: { login, search, quantity, page }
  const res = await axios.get(`${baseUrl}/admin/historical`, {
    headers,
    params,
  });
  return res;
};

const adminMethods = {
  accountsService,
  createSignalAccount,
  createFollowerAccount,
  editAccounts,
  deleteAccounts,
  getGroups,
  getInformation,
  getAdminLogs,
  getHistoricalSettings,
};

export default adminMethods;